import React from 'react';
import { Phone, CalendarDays, CheckCircle2 } from 'lucide-react'; // Using Lucide icons

export default function CTASection({
  title = "Ready to Fix Your Sleep Apnea and Breathe Better?",
  subtitle = "Don't let sleep disorders affect your quality of life. Our expert specialists are ready to guide you toward restful nights and energized days."
}) {
  return (
    <section className="py-24 px-6 bg-gradient-to-b from-white to-accent1/5">
      <div className="max-w-4xl mx-auto text-center">
        {/* Badge */}
        <span className="inline-block px-4 py-1 mb-6 text-sm font-semibold tracking-wider text-primary uppercase bg-primary/10 rounded-full">
          Take Control Today
        </span>

        <h2 className="text-4xl md:text-5xl font-extrabold text-secondary mb-6 leading-tight">
          {title}
        </h2>
        
        <p className="text-xl text-gray-600 mb-10 max-w-2xl mx-auto leading-relaxed">
          {subtitle}
        </p>

        {/* Benefits List */}
        <div className="flex flex-wrap justify-center gap-6 mb-12 text-sm md:text-base text-gray-700">
          {['Expert Specialists', 'Personalized Care', 'Advanced Diagnostics'].map((item) => (
            <div key={item} className="flex items-center gap-2">
              <CheckCircle2 className="w-5 h-5 text-primary" />
              <span className="font-medium">{item}</span>
            </div>
          ))}
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <a
            href="https://api.whatsapp.com/send?phone=917013686917&text=I%20would%20like%20to%20book%20a%20consultation"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 bg-primary hover:bg-secondary text-white px-8 py-4 rounded-xl font-bold transition-all shadow-lg hover:shadow-primary/25 text-lg"
          >
            <CalendarDays className="w-5 h-5" />
            Book Your Consultation
          </a>
          
          <a
            href="tel:+917013686917"
            className="flex items-center justify-center gap-2 bg-white text-secondary border-2 border-gray-100 hover:border-primary hover:text-primary px-8 py-4 rounded-xl font-bold transition-all shadow-sm hover:shadow-md text-lg"
          >
            <Phone className="w-5 h-5" />
            Call: +91 7013686917
          </a>
        </div>
        
        <p className="mt-8 text-sm text-gray-400">
          Available Thusday - Tuesday: 10:00am – 2:00pm & 3:30pm - 7:30pm and Wednesday: Closed
        </p>
      </div>
    </section>
  );
}